import { Box, Button, Heading, HStack, Image, Text, VStack, useDisclosure } from '@chakra-ui/react'
import React from 'react'
import { Layout, BVN } from '../../../components'
import { AuthContext } from '../../../context/auth/index.js'
import useMotorStore from '../../../state/Motor.store'
import { money } from '../../../utils/formatter'
import { screens } from './types'

const MotorPolicy = () => {
  const { authState } = React.useContext(AuthContext)
  const isLoggedIn = authState?.token

  const { isOpen, onOpen, onClose } = useDisclosure()
  const [vehicleDetails, setScreen, policy, onboardBuyPolicy, buyPolicy, loading] = useMotorStore(
    (state) => [
      state.vehicleDetails,
      state.setScreen,
      state.policy,
      state.onboardBuyPolicy,
      state.buyPolicy,
      state.loading
    ]
  )

  const onSubmit = async () => {
    if (isLoggedIn) {
      await buyPolicy()
    } else {
      await onboardBuyPolicy()
    }
    setScreen(screens.MOTOR_SUMMARY)
  }

  return (
    <>
      <Layout previous={() => setScreen(screens.MOTOR_DETAILS)} title="Buy a Third Party Policy">
        <Box flex={1}>
          <Image mt="3rem" mb="3.2rem" mx="auto" maxW="181px" src="/images/car.png" />
          <HStack
            justify="space-between"
            w="100%"
            boxShadow="0px 4px 12px rgba(154, 160, 166, 0.04)"
            borderRadius="1.2rem"
            px="1.6rem"
            py="1.1rem"
            bg="white">
            <VStack align="flex-start">
              <Text fontSize="1rem">Brand/Model</Text>
              <Text color="black" fontWeight="500" fontSize="1.2rem">
                {`${vehicleDetails.make} / ${vehicleDetails.model}`}
              </Text>
            </VStack>
            <VStack align="flex-start">
              <Text fontSize="1rem">Vehicle Plate Number</Text>
              <Text color="black" fontWeight="500" fontSize="1.2rem">
                {vehicleDetails.plate_number.toUpperCase()}
              </Text>
            </VStack>
            <VStack align="flex-start">
              <Text fontSize="1rem">Year</Text>
              <Text color="black" fontWeight="500" fontSize="1.2rem">
                {vehicleDetails.year || '-'}
              </Text>
            </VStack>
          </HStack>
          <HStack
            border="1px dashed #0AB86F"
            justify="space-between"
            bg="rgba(223, 246, 240, 0.2)"
            py="1.3rem"
            mb="2rem"
            borderRadius="1.2rem"
            mt="1.6rem"
            px="3rem">
            <HStack>
              <Image mr="1.2rem" src="/images/shield.svg" />
              <Text color="brand.blue">
                Third Party <br /> Policy
              </Text>
            </HStack>
            <VStack align="flex-start">
              <Heading color="brand.blue">{money(policy.value)}</Heading>
              <Text fontSize="1rem" color="black">
                per {policy.period}
              </Text>
            </VStack>
          </HStack>
        </Box>
        <Button
          isLoading={loading}
          onClick={() => (isLoggedIn ? onSubmit() : onOpen())}
          variant="green">
          Buy This Policy
        </Button>
      </Layout>
      <BVN route={() => setScreen(screens.MOTOR_SUMMARY)} onClose={onClose} isOpen={isOpen} />
    </>
  )
}

export { MotorPolicy }
